<template>
  <p class="app-form-label" :class="className">
    <slot />
  </p>
</template>

<script>
export default {
  name: 'AppFormLabel',

  props: {
    required: {
      type: Boolean,
      default: false,
    },

    invalid: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    className() {
      const { required, invalid } = this;

      return {
        'app-form-label--required': required,
        'app-form-label--invalid': invalid,
      };
    },
  },
};
</script>

<style lang="scss">
.app-form-label {
  a {
    color: inherit;
  }

  &--invalid {
    color: #ff0000;
  }

  &--required::before {
    content: '*';

    margin-right: 0.25em;

    font-weight: 900;
    color: #ff0000;
  }
}
</style>
